import { render } from "./ReviewSection.vue?vue&type=template&id=9a3c3a0c&scoped=true"
import script from "./ReviewSection.vue?vue&type=script&lang=js"
export * from "./ReviewSection.vue?vue&type=script&lang=js"

import "./ReviewSection.vue?vue&type=style&index=0&id=9a3c3a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3c3a0c"]])

export default __exports__